import objectFitPolyfill from 'imports-loader?this=>window!exports-loader?objectFitPolyfill!objectFitPolyfill';
import app from '../../../general/js/app';
import BaseComponent from '../../../general/js/base-component';

const BROWSER_HAVE_ENOUGH_DATA = 4;

export default class ObjectFitVideoComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        this.video = this.element.querySelector('video');

        this.onReadyStateChange = this.onReadyStateChange.bind(this);
        this.onCanPlayThrough = this.onCanPlayThrough.bind(this);
        this.init();
    }

    init() {
        if (!app.isTouch) {
            if (this.isReady()) {
                this.play();
            } else {
                this.addListeners();
            }
        }
    }

    addListeners() {
        this.video.addEventListener('readystatechange', this.onReadyStateChange);
        this.video.addEventListener('canplaythrough', this.onCanPlayThrough);
    }

    removeListeners() {
        this.video.removeEventListener('readystatechange', this.onReadyStateChange);
        this.video.removeEventListener('canplaythrough', this.onCanPlayThrough);
    }

    isReady() {
        return this.video.readyState === BROWSER_HAVE_ENOUGH_DATA;
    }


    onReadyStateChange() {
        if (this.isReady()) {
            this.removeListeners();
            this.play();
        }
    }

    onCanPlayThrough() {
        this.removeListeners();
        this.play();
    }

    play() {
        objectFitPolyfill(this.video);
        this.video.play();
        this.element.classList.add('is-started');
    }
}



// WEBPACK FOOTER //
// ./app/components/hero-video/js/hero-video.component.js